<template>
    <div data-test-view="reviews-assessments">
        <l-card-content>
            <l-headline
                :title="$t(`reviews.list.titleToDo`)"
                :tabs="tabs"
                has-search-bar
                :search-input-placeholder="$t(`reviews.list.searchPlaceholder`)"
                @search="toDoSearch"
            />

            <hr class="visible-xs" />

            <!-- Open tasks -->

            <l-no-data
                v-show="
                    !reviewCycleList.toDo.length &&
                        !reviewCycleList.received.length &&
                        !reviewCycleList.given.length
                "
                :text="$t(`reviews.list.toDoEmptyH1`)"
            />

            <div v-show="Boolean(filteredToDos.length || filteredToDosFromCycle.length)">
                <l-reviews-assessments-open
                    :reviews-from-cycle="filteredToDosFromCycle"
                    :reviews-from-participant="filteredToDos"
                    :user="user"
                />
            </div>

            <!-- End open tasks -->
        </l-card-content>

        <!-- My Reviews -->

        <div v-show="Boolean(filteredReceived.length)">
            <l-card-content>
                <l-reviews-assessments-received :reviews="filteredReceived" :user="user" />
            </l-card-content>
        </div>

        <!-- Completed Tasks -->

        <div v-if="Boolean(filteredGiven.length)">
            <l-card-content>
                <l-reviews-assessments-completed :reviews="filteredGiven" />
            </l-card-content>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import { chronologically, alphabetically } from "@/utils/sort-object";

import LCardContent from "@/components/LCardContent";
import LHeadline from "@/components/LHeadline";
import LNoData from "@/components/LNoData";

import LReviewsAssessmentsCompleted from "@/components/LReviewsAssessmentsCompleted";
import LReviewsAssessmentsOpen from "@/components/LReviewsAssessmentsOpen";
import LReviewsAssessmentsReceived from "@/components/LReviewsAssessmentsReceived";

export default {
    components: {
        LCardContent,
        LHeadline,
        LNoData,

        LReviewsAssessmentsCompleted,
        LReviewsAssessmentsOpen,
        LReviewsAssessmentsReceived,
    },
    data() {
        return {
            toDoFilter: null,
            sortBy: "deadline",
            sortByDirection: "asc",
        };
    },
    computed: {
        ...mapGetters({
            user: "users/current/user",
            reviewCycleList: "reviews/assessments/list",
        }),
        tabs() {
            return [
                {
                    show: true,
                    label: this.$t(`reviews.list.sortDeadline`),
                    active: this.sortBy === "deadline",
                    iconBeforeLabel: true,
                    icon:
                        this.sortBy === "deadline" && this.sortByDirection === "desc"
                            ? "fal fa-sort-amount-down"
                            : this.sortBy === "deadline"
                            ? "fal fa-sort-amount-up"
                            : "",
                    handler: () => this.selectSort("deadline"),
                },
                {
                    show: true,
                    label: this.$t(`reviews.list.sortCycle`),
                    active: this.sortBy === "name",
                    iconBeforeLabel: true,
                    icon:
                        this.sortBy === "name" && this.sortByDirection === "desc"
                            ? "fal fa-sort-amount-down"
                            : this.sortBy === "name"
                            ? "fal fa-sort-amount-up"
                            : "",
                    handler: () => this.selectSort("name"),
                },
                {
                    show: true,
                    label: this.$t(`reviews.list.sortEmployee`),
                    active: this.sortBy === "reviewee.fullname",
                    iconBeforeLabel: true,
                    icon:
                        this.sortBy === "reviewee.fullname" && this.sortByDirection === "desc"
                            ? "fal fa-sort-amount-down"
                            : this.sortBy === "reviewee.fullname"
                            ? "fal fa-sort-amount-up"
                            : "",
                    handler: () => this.selectSort("reviewee.fullname"),
                },
                {
                    show: true,
                    label: this.$t(`reviews.list.sortType`),
                    active: this.sortBy === "type",
                    iconBeforeLabel: true,
                    icon:
                        this.sortBy === "type" && this.sortByDirection === "desc"
                            ? "fal fa-sort-amount-down"
                            : this.sortBy === "type"
                            ? "fal fa-sort-amount-up"
                            : "",
                    handler: () => this.selectSort("type"),
                },
            ];
        },
        filteredToDos() {
            if (this.toDoFilter !== null && this.toDoFilter.reviewee.fullname) {
                let list = (this.reviewCycleList.toDo || []).filter(todo => {
                    return todo?.reviewee?.fullname
                        ?.toLowerCase()
                        ?.includes(this.toDoFilter.reviewee.fullname);
                });

                return this.sortList(list);
            }

            return this.sortList(this.reviewCycleList.toDo);
        },
        filteredToDosFromCycle() {
            if (this.toDoFilter !== null && this.toDoFilter.reviewee.fullname) {
                let list = (this.reviewCycleList.toDoFromCycle || []).filter(todo => {
                    return todo?.reviewee?.fullname
                        ?.toLowerCase()
                        ?.includes(this.toDoFilter.reviewee.fullname);
                });

                return this.sortList(list);
            }

            return this.sortList(this.reviewCycleList.toDoFromCycle);
        },
        filteredReceived() {
            if (this.toDoFilter !== null && this.toDoFilter.reviewee.fullname) {
                let list = (this.reviewCycleList.received || []).filter(todo => {
                    return todo?.reviewee?.fullname
                        ?.toLowerCase()
                        ?.includes(this.toDoFilter.reviewee.fullname);
                });

                return this.sortList(list);
            }

            return this.sortList(this.reviewCycleList.received);
        },
        filteredGiven() {
            if (this.toDoFilter !== null && this.toDoFilter.reviewee.fullname) {
                let list = (this.reviewCycleList.given || []).filter(todo => {
                    return todo?.reviewee?.fullname
                        ?.toLowerCase()
                        ?.includes(this.toDoFilter.reviewee.fullname);
                });

                return this.sortList(list);
            }
            return this.sortList(this.reviewCycleList.given);
        },
    },
    methods: {
        toDoSearch(query) {
            this.toDoFilter = { reviewee: { fullname: query.toLowerCase() } };
        },
        selectSort(sortBy) {
            if (sortBy === this.sortBy) {
                // change direction
                this.sortByDirection = this.sortByDirection === "desc" ? "asc" : "desc";
            }

            this.sortBy = sortBy || "deadline";
        },
        sortList(list) {
            if (!list) {
                list = [];
            }

            list = Array.from(list);

            if (this.sortBy === "deadline") {
                return list.sort(chronologically(this.sortBy, this.sortByDirection));
            } else {
                return list.sort(alphabetically(this.sortBy, this.sortByDirection));
            }
        },
    },
};
</script>
